import type {Option as TOption} from './Option';
import type TReference from './Reference';

class Component {
	readonly option: TOption;
	readonly name: string;
	readonly reference: TReference | null;
	readonly sku: TReference | null;
	readonly gtin: TReference | null;
	readonly imageURL: string | null;

	serialize(): Component.ISerialized {
		return (Object.assign(
			{
				name: this.name
			}, {
				reference: this.reference ? this.reference.serialize() : null,
				sku: this.sku ? this.sku.serialize() : null,
				gtin: this.gtin ? this.gtin.serialize() : null,
				imageURL: this.imageURL || null
			}
		));
	};

	constructor(desc: Component.IDescriptor) {
		this.option = desc.option;
		this.name = desc.name;
		this.imageURL = desc.imageURL || null;
		this.reference = null;
		if (desc.reference) {
			if (typeof desc.reference === 'string') {
				this.reference = new window.BasketNS.Reference(desc.reference);
			} else {
				this.reference = new window.BasketNS.Reference(desc.reference.value);
			}
		}
		this.sku = null;
		if (desc.sku) {
			if (typeof desc.sku === 'string') {
				this.sku = new window.BasketNS.Reference(desc.sku);
			} else {
				this.sku = new window.BasketNS.Reference(desc.sku.value);
			}
		}
		this.gtin = null;
		if (desc.gtin) {
			if (typeof desc.gtin === 'string') {
				this.gtin = new window.BasketNS.Reference(desc.gtin);
			} else {
				this.gtin = new window.BasketNS.Reference(desc.gtin.value);
			}
		}
	};
};
namespace Component {
	export interface IDescriptor {
		readonly option: TOption;
		readonly name: string;
		readonly reference: string | TReference.ISerialized | null;
		readonly sku: string | TReference.ISerialized | null;
		readonly gtin: string | TReference.ISerialized | null;
		readonly imageURL: string | null;
	};

	export interface ISerialized {
		readonly name: string;
		readonly reference: TReference.ISerialized | null;
		readonly sku: TReference.ISerialized | null;
		readonly gtin: TReference.ISerialized | null;
		readonly imageURL: string | null;
	};

}
export default Component;